export default "__VITE_ASSET__DvVLvoJx__"